module.exports = __webpack_public_path__ + "static/media/item_27_5.f14c56ee.png";